export default function ApiConfig() {
  return (
    'patdnnQKmnp3pOmOG.08a8b5ded50a7869888403da10afd852e3a19209b22b963e4ca16363eaa12558'
  );
}



// WEBPACK FOOTER //
// ./src/config.js